export class Calendar {
    constructor(options) {
        this.options = options;
        this.today = new Date();
        this.eventDates = [];
        this.eventData = [];
        this.year = this.today.getFullYear();
        this.month = this.today.getMonth();
        this.monthLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        this.days = document.getElementsByClassName('day-cell');
        this.daysLen = this.days.length;
        this.setDate;

        this.draw();
    }

    /**
     * Initial draw of the calendar
     */
    draw() {
        this.getOptions();
        this.drawHeader();
        this.drawDays();

        // Add click functions
        let prev = document.getElementsByClassName('prev-button'),
            next = document.getElementsByClassName('next-button');

        prev[0].addEventListener('click', () => this.prevMonth());
        next[0].addEventListener('click', () => this.nextMonth());

        for (let i = 0; i < this.daysLen; i++) {
            this.days[i].addEventListener('click', (event) => this.clickDay(event.target));
        }
    }

    /**
     * Update the calendar header
     */
    drawHeader() {
        // Set header month text
        document.getElementsByClassName('head-month')[0].innerHTML = this.monthLabels[this.month];

        // Set year label
        document.getElementsByClassName('calendar-year')[0].innerHTML = this.year;
    }

    /**
     * Update the calendar days table
     */
    drawDays() {

        // Draw dates for previous month and upcoming month


        let startDay = new Date(this.year, this.month, 1).getDay(),

            // The following indicates the total number of days in the month
            numberOfDays = new Date(this.year, this.month + 1, 0).getDate(),

            // Get days in previous month
            prevMonthDays = new Date(this.year, this.month, 0).getDate(),

            n = startDay;

        // Set Monday as the first day of the week
        n = (n === 0) ? 6 : n - 1;

        // Clear original style and date
        for (let k = 0; k < 42; k++) {
            // this.days[k].innerHTML = '';
            this.days[k].className = 'day-cell';
            delete this.days[k].dataset.calendarDate;
            delete this.days[k].dataset.calendarInfo;
            this.days[k].dataset.bsToggle = '';
            this.days[k].dataset.bsPlacement = '';
            this.days[k].dataset.bsHtml = 'false';
            this.days[k].dataset.bsTitle = '';
        }

        // Add days from previous month
        let prevMonth = this.month === 0 ? 11 : this.month - 1;
        let prevMonthYear = this.month === 0 ? this.year - 1 : this.year;
        for (let i = n - 1; i >= 0; i--) {
            let day = prevMonthDays - (n - 1 - i);
            this.days[i].innerHTML = day;
            this.days[i].classList.add('day-other-month');
            this.days[i].dataset.calendarDate = prevMonthYear + '-' + String(prevMonth + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0');
        }

        // Add dates as content
        for (let i = 1; i <= numberOfDays; i++) {
            this.days[n].innerHTML = i;
            this.days[n].dataset.calendarDate = this.year + '-' + String(this.month + 1).padStart(2, '0') + '-' + String(i).padStart(2, '0');
            n++;
        }

        // Add days from next month
        let nextMonth = this.month === 11 ? 0 : this.month + 1;
        let nextMonthYear = this.month === 11 ? this.year + 1 : this.year;
        let nextMonthDay = 1;

        // Handle other months
        for (let i = n; i < 42; i++) {
            this.days[i].innerHTML = nextMonthDay;
            this.days[i].classList.add('day-other-month');
            this.days[i].dataset.calendarDate = nextMonthYear + '-' + String(nextMonth + 1).padStart(2, '0') + '-' + String(nextMonthDay).padStart(2, '0');
            nextMonthDay++;
        }

        // Draw all possible day cells
        for (let j = 0; j < 42; j++) {

            // Disabled if there is no content
            if (this.days[j].innerHTML === '') {
                this.days[j].classList.add('day-disabled');
            }

            // Date string of the current day in iteration
            let dayDateString = this.days[j].dataset.calendarDate;

            // Add today class
            let yearToday = this.today.getFullYear();
            let monthToday = (this.today.getMonth() + 1).toString().padStart(2, '0');  // Months are zero-based, so add 1
            let dayToday = this.today.getDate().toString().padStart(2, '0');
            let todayFormatted = `${yearToday}-${monthToday}-${dayToday}`;
            if (dayDateString === todayFormatted) {
                this.days[j].classList.add('day-today');
            }

            // Mark all events
            if (this.eventDates && this.eventDates.includes(dayDateString)) {
                this.days[j].classList.add('day-has-event');
            }

            // Add event data to cells
            if (typeof this.eventData === 'object' && this.eventData.hasOwnProperty(dayDateString)) {
                this.days[j].dataset.calendarInfo = JSON.stringify(this.eventData[dayDateString]);

                // Add tooltips
                this.days[j].dataset.bsToggle = 'tooltip';
                this.days[j].dataset.bsPlacement = 'bottom';
                this.days[j].dataset.bsHtml = 'true';
                // Implode event titles
                this.days[j].dataset.bsTitle = this.eventData[dayDateString].map(event => event.title).join('<br>-<br>');
            }

            // Mark weekends
            let isWeekend = (j % 7 === 6 || j % 7 === 5) ? 'weekend' : 'weekday';
            this.days[j].classList.add('day-' + isWeekend);
        }

        // Initialize tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    }

    /**
     * Load previous month
     */
    prevMonth() {
        if (this.month === 0) {
            this.month = 11;
            this.year--;
        } else {
            this.month--;
        }
        this.drawHeader();
        this.drawDays();
    }

    /**
     * Load next month
     */
    nextMonth() {
        if (this.month === 11) {
            this.month = 0;
            this.year++;
        } else {
            this.month++;
        }
        this.drawHeader();
        this.drawDays();
    }

    /**
     * Click on a day
     *
     * @param dayElement
     */
    clickDay(dayElement) {

        if (!dayElement.dataset.calendarInfo) {
            return false;
        }

        // Mark the clicked day as active
        // Remove active from all other days
        for (let i = 0; i < this.daysLen; i++) {
            this.days[i].classList.remove('active');
        }
        dayElement.classList.add('active');

        let carouselHTML = '';

        // If no event data, clear the box
        if (dayElement.dataset.calendarInfo) {

            // Get the clicked date
            let dayDate = new Date(dayElement.dataset.calendarDate);

            // Get the event data
            let body = JSON.parse(dayElement.dataset.calendarInfo);

            // Generate event list carousel
            carouselHTML += '<div id="event-carousel" class="carousel slide h-100 px-5">';
            carouselHTML += '<div class="carousel-inner d-flex align-items-center h-100">';

            let i = 0;
            body.forEach(item => {

                let activeClass = (i === 0) ? 'active' : '';

                carouselHTML += '<div class="carousel-item ' + activeClass + '">';

                let date = (item.from === item.to) ? item.from : item.from + ' - ' + item.to;
                carouselHTML += `<div class="mb-4">
                                <h4 class="text-light-purple text-uppercase">
                                    <span class="fw-bold"
                                          data-calendar-box="calendar-date">${date}</span>
                                </h4>
        
                                <h2 class="text-uppercase text-white fw-bold fs-1"
                                    data-calendar-box="calendar-title">
                                        ${item.title}
                                </h2>
        
                            </div>
        
                            <div class="row">
        
                                <div class="col-6">
        
                                    <div class="mb-4">
                                        <img class="w-100"
                                             data-calendar-box="calendar-image"
                                             src="${item.featured_image}">
                                    </div>
        
                                    <a href="${item.url}"
                                       data-calendar-box="calendar-link"
                                       class="btn btn-primary">See More</a>
        
                                </div>
        
                                <div class="col-6">
        
                                    <div class="text-white"
                                         data-calendar-box="calendar-content">
                                         ${item.excerpt}
                                    </div>
        
                                </div>
        
                            </div>`;

                carouselHTML += '</div>';

                ++i;
            });
            carouselHTML += '</div>'; // carousel-inner

            // Show controls
            if (body.length > 1) {
                carouselHTML += `
            <button class="carousel-control-prev" type="button" data-bs-target="#event-carousel" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#event-carousel" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>`;
            }

            carouselHTML += '</div>';
        }

        document.getElementById('calendar-box').innerHTML = carouselHTML;
    }

    /**
     * Parse initial options
     */
    getOptions() {

        if (this.options) {

            this.setDate = this.today;

            // All event dates
            this.eventDates = this.options.eventDates ?? false;

            // All event data
            this.eventData = this.options.eventData ?? false;

            this.year = this.setDate.getFullYear();
            this.month = this.setDate.getMonth();
        }
    }
}
